import AbstractModel, { Model, DateType } from './abstract-model';

@Model('Query')
export default class Query extends AbstractModel {
  public numDept: string = null;
  public numInsee: string = null;
  public numCavite: string = null;
  public numCavites: string[] = null;
  public nomCavite: string = null;
  public coordX: number = null;
  public coordY: number = null;
  public statutV: number = null;
  public statutR: number = null;
  public confidentialite: string = null;
  public libelleSourceInfo: string = null;
  public typeCavite: number = null;
  public idCus: string = null;
  
  /* AVENANT 2014 */
  @DateType() public preconisationEcheanceStart: Date = null;
  @DateType() public preconisationEcheanceEnd: Date = null;

  public get preconisationEcheanceDateRange(): {start: Date, end: Date} {
    return {
      start: this.preconisationEcheanceStart,
      end: this.preconisationEcheanceEnd
    };
  }

  public set preconisationEcheanceDateRange(r: {start: Date, end: Date}) {
    this.preconisationEcheanceStart = r.start;
    this.preconisationEcheanceEnd = r.end;
  }
  
  public sortField: string = null;
  public sortOrder: string = null;


  public get notEmpty(): boolean {
    return Object.keys(this).filter(k => !~["@class", "sortField", "sortOrder"].indexOf(k))
      .map(k => this[k]).some(v => v != null);
  }
  
}

